<template>
    <div v-if="data.length && dataLoaded">
        <div class="single" v-if="type == 2">
            <vue-glide ref="vueglider" @glide:mount-after="update"
                :perView="1"
                :autoplay="10000">
                <vue-glide-slide v-for="(item, index) in data" :key="index">
                    <div>
                        <div class="name" v-if="item.rater != ''">
                            <i v-if="userIcon" class="fa fa-user-circle-o"></i>
                            <template v-if="item.rater.split(' ').length >= 2">{{ item.rater.split(' ')[0] | truncate(30, '...') }} {{ item.rater.split(' ')[1].slice(0,1) }}.</template>
                            <template v-else>{{ item.rater | truncate(30, '...') }}</template>
                        </div>
                        <div class="name" v-else><i v-if="userIcon" class="fa fa-user-circle-o"></i>{{ $translate("reviewWidget::Template.guest") }}</div>
                        <div class="date">
                            {{ item.date.split('-')[2] }}.{{ item.date.split('-')[1] }}.{{ item.date.split('-')[0] }}
                        </div>
                        <div class="stars">
                            <template v-for="index in item.stars * 1"><i class="fa fa-star"></i></template>
                            <template v-for="index in 5 - (item.stars * 1)"><i class="fa fa-star grey"></i></template>
                        </div>
                        <div class="comment" v-if="(limit && limitNumber) && item.comment.replaceAll('????', '').trim().split(' ').length > limitNumber">
                            <template v-for="(comment, index) in item.comment.replaceAll('????', '').trim().split(' ')" v-if="index < limitNumber">{{ comment }} </template><span class="ppp">...</span>
                            <span class="limiter">{{ $translate("reviewWidget::Template.limiter") }}</span>
                            <span class="show-more"><template v-for="(comment, index) in item.comment.split(' ')" v-if="index >= limitNumber">{{ comment.replace('????', '') }} </template></span>
                        </div>
                        <div class="comment b" v-else>
                            <template v-if="item.comment == ''">
                                "{{ item.title }}"
                            </template>
                            <template v-else>
                                "{{ item.comment.replaceAll('????', '').trim() }}"
                            </template>
                        </div>
                        <template v-for="image in variations.documents" v-if="variations.total > 0 && !noImage">
                            <template v-if="image.id == item.relationId">
                                <div class="img" @click="directToItem('/' + image.data.texts.urlPath + '_' + image.data.item.id + '_' + image.id)">
                                    <lazy-img v-if="image.data.images.variation.length > 0" :image-url="image.data.images.variation[0].urlPreview" :alt="image.data.texts.name1"></lazy-img>
                                    <lazy-img v-else :image-url="image.data.images.all[0].urlPreview" :alt="image.data.texts.name1"></lazy-img>
                                    <span class="date">{{ image.data.texts.name1 | truncate(60, '...') }}</span>
                                </div>
                            </template>
                        </template>
                    </div>
                </vue-glide-slide>
                <template slot="control">
                    <button data-glide-dir="<"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                    <button data-glide-dir=">"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                </template>
            </vue-glide>
        </div>
        <div v-else-if="type == 1">
            <ul>
                <li v-for="(item, index) in data" :key="index">
                    <div>
                        <div class="name" v-if="item.rater != ''">
                            <i v-if="userIcon" class="fa fa-user-circle-o"></i>
                            <template v-if="item.rater.split(' ').length >= 2">{{ item.rater.split(' ')[0] | truncate(30, '...') }} {{ item.rater.split(' ')[1].slice(0,1) }}.</template>
                            <template v-else>{{ item.rater | truncate(30, '...') }}</template>
                        </div>
                        <div class="name" v-else><i v-if="userIcon" class="fa fa-user-circle-o"></i>{{ $translate("reviewWidget::Template.guest") }}</div>
                        <div class="date">
                            {{ item.date.split('-')[2] }}.{{ item.date.split('-')[1] }}.{{ item.date.split('-')[0] }}
                        </div>
                        <div class="stars">
                            <template v-for="index in item.stars * 1"><i class="fa fa-star"></i></template>
                            <template v-for="index in 5 - (item.stars * 1)"><i class="fa fa-star grey"></i></template>
                        </div>
                        <div class="comment" v-if="(limit && limitNumber) && item.comment.replaceAll('????', '').trim().split(' ').length > limitNumber">
                            <template v-for="(comment, index) in item.comment.replaceAll('????', '').split(' ')" v-if="index < limitNumber">{{ comment }} </template><span class="ppp">...</span>
                            <span class="limiter">{{ $translate("reviewWidget::Template.limiter") }}</span>
                            <span class="show-more"><template v-for="(comment, index) in item.comment.replaceAll('????', '').trim().split(' ')" v-if="index >= limitNumber">{{ comment }} </template></span>
                        </div>
                        <div class="comment" v-else>
                            <template v-if="item.comment == ''">
                                "{{ item.title }}"
                            </template>
                            <template v-else>
                                "{{ item.comment.replaceAll('????', '').trim() }}"
                            </template>
                        </div>
                        <template v-for="image in variations.documents" v-if="variations.total > 0">
                            <template v-if="image.id == item.relationId">
                                <div class="img" @click="directToItem('/' + image.data.texts.urlPath + '_' + image.data.item.id + '_' + image.id)">
                                    <lazy-img v-if="image.data.images.variation.length > 0" :image-url="image.data.images.variation[0].urlPreview" :alt="image.data.texts.name1"></lazy-img>
                                    <lazy-img v-else :image-url="image.data.images.all[0].urlPreview" :alt="image.data.texts.name1"></lazy-img>
                                    <span class="date">{{ image.data.texts.name1 | truncate(60, '...') }}</span>
                                </div>
                            </template>
                        </template>
                    </div>
                </li>
            </ul>
        </div>
        <div class="multi" v-else>
            <vue-glide ref="vueglider" @glide:mount-after="update"
                :perView="4"
                :gap="20"
                :bound="true"
                :autoplay="10000"
                :breakpoints="{ '575':{ perView: 1 },'879':{ perView: 2 },'1199':{ perView: 3 } }">
                <vue-glide-slide v-for="(item, index) in data" :key="index">
                    <div>
                        <div class="name" v-if="item.rater != ''">
                            <i v-if="userIcon" class="fa fa-user-circle-o"></i>
                            <template v-if="item.rater.split(' ').length >= 2">{{ item.rater.split(' ')[0] | truncate(30, '...') }} {{ item.rater.split(' ')[1].slice(0,1) }}.</template>
                            <template v-else>{{ item.rater | truncate(30, '...') }}</template>
                        </div>
                        <div class="name" v-else><i v-if="userIcon" class="fa fa-user-circle-o"></i>{{ $translate("reviewWidget::Template.guest") }}</div>
                        <div class="date">
                            {{ item.date.split('-')[2] }}.{{ item.date.split('-')[1] }}.{{ item.date.split('-')[0] }}
                        </div>
                        <div class="stars">
                            <template v-for="index in item.stars * 1"><i class="fa fa-star"></i></template>
                            <template v-for="index in 5 - (item.stars * 1)"><i class="fa fa-star grey"></i></template>
                        </div>
                        <div class="comment" v-if="(limit && limitNumber) && item.comment.replaceAll('????', '').trim().split(' ').length > limitNumber">
                            <template v-for="(comment, index) in item.comment.replaceAll('????', '').trim().split(' ')" v-if="index < limitNumber">{{ comment }} </template><span class="ppp">...</span>
                            <span class="limiter">{{ $translate("reviewWidget::Template.limiter") }}</span>
                            <span class="show-more"><template v-for="(comment, index) in item.comment.replaceAll('????', '').trim().split(' ')" v-if="index >= limitNumber">{{ comment }} </template></span>
                        </div>
                        <div class="comment b" v-else>
                            <template v-if="item.comment == ''">
                                "{{ item.title }}"
                            </template>
                            <template v-else>
                                "{{ item.comment.replaceAll('????', '').trim() }}"
                            </template>
                        </div>
                        <template v-for="image in variations.documents" v-if="variations.total > 0 && !noImage">
                            <template v-if="image.id == item.relationId">
                                <div class="img" @click="directToItem('/' + image.data.texts.urlPath + '_' + image.data.item.id + '_' + image.id)" data-toggle="tooltip" :title='$translate("Ceres::Template.itemShowItem")'>
                                    <lazy-img v-if="image.data.images.variation.length > 0" :image-url="image.data.images.variation[0].urlPreview" :alt="image.data.texts.name1"></lazy-img>
                                    <lazy-img v-else :image-url="image.data.images.all[0].urlPreview" :alt="image.data.texts.name1"></lazy-img>
                                    <span class="date">{{ image.data.texts.name1 | truncate(60, '...') }}</span>
                                </div>
                            </template>
                        </template>
                    </div>
                </vue-glide-slide>
                <template slot="control">
                    <button data-glide-dir="<"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                    <button data-glide-dir=">"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                </template>
            </vue-glide>
        </div>
    </div>
    <div v-else class="pholder">
        <div class="single" v-if="type == 2">
            <vue-glide ref="vueglider" @glide:mount-after="update"
                :perView="1"
                :autoplay="10000">
                <vue-glide-slide v-for="n in 4" :key="n">
                    <div>
                        <div class="name">
                            <i v-if="userIcon" class="fa fa-user-circle-o"></i>
                            <span class="a-bg">&nbsp;</span>
                        </div>
                        <div class="date">
                            <span class="a-bg">&nbsp;</span>
                        </div>
                        <div class="stars">
                            <template v-for="n in 5"><i class="fa fa-star grey"></i></template>
                        </div>
                        <div class="comment">
                            <span class="a-bg">Comment</span>
                        </div>
                    </div>
                </vue-glide-slide>
                <template slot="control">
                    <button data-glide-dir="<"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                    <button data-glide-dir=">"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                </template>
            </vue-glide>
        </div>
        <ul class="multi" v-else>
            <li v-for="n in 4">
                <div>
                    <div class="name">
                        <i v-if="userIcon" class="fa fa-user-circle-o"></i>
                        <span class="a-bg">&nbsp;&nbsp;&nbsp;</span>
                    </div>
                    <div class="date">
                        <span class="a-bg">&nbsp;</span>
                    </div>
                    <div class="stars">
                        <template v-for="n in 5"><i class="fa fa-star grey"></i></template>
                    </div>
                    <div class="comment">
                        <span class="a-bg">&nbsp;</span>
                        <span class="a-bg">&nbsp;</span>
                        <span class="a-bg">&nbsp;</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { Glide, GlideSlide } from 'vue-glide-js';

    export default {
        components: {
            [Glide.name]: Glide,
            [GlideSlide.name]: GlideSlide
        },
        data: function() {
            return {
                data:[],
                dataLoaded: false,
                varIDs: [],
                variations: {
                    "data":{
                        "total": 0
                    }
                }
            }
        },
        props: {
            limit: false,
            limitNumber: Number,
            noImage: false,
            type: Number,
            userIcon: false
        },
        mounted() {
            var self = this,
            data = [],
            varIDs = [],
            variationString = "",
            variations = {};

            $.getJSON('/rest/reviewWidget/get/selection').done(function( data ) {
                self.data = data;
                self.dataLoaded = true;

                for (var i = 0; i < self.data.length; i++) {
                    if (i) {
                        if (!varIDs.includes(self.data[i].relationId)) {
                            varIDs.push(self.data[i].relationId);
                            variationString += "&variationIds[]=" + self.data[i].relationId;
                        }
                    } else {
                        if (!varIDs.includes(self.data[i].relationId)) {
                            varIDs.push(self.data[i].relationId);
                            variationString += "variationIds[]=" + self.data[i].relationId;
                        }
                    }
                }

                self.varIDs = varIDs;

                $.getJSON('/rest/io/variations?' + variationString).done(function( result ) {
                    self.variations = result.data;
                })
            })
        },
        methods: {
            update: function() {
                // only because shopbuilder
                var self = this;
                setTimeout(function() {
                    self.$refs.vueglider.glide.update();
                }, 500);
            },
            directToItem: function(url) {
                window.location.href = url;
            }
        }
    }
</script>
